"use client";

import { useState } from "react";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { algoliaSearchService } from "@/lib/services/algolia-search-service";

export function AlgoliaTestComponent() {
  const [testResults, setTestResults] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);

  const runTests = async () => {
    setIsLoading(true);
    const results: any = {};

    try {
      const patientSearch = await algoliaSearchService.searchPatients("John Doe", { limit: 5 });
      results.patientSearch = patientSearch;
      const documentSearch = await algoliaSearchService.searchDocuments("lab report", { limit: 5 });
      results.documentSearch = documentSearch;
      const procedureSearch = await algoliaSearchService.searchProcedures("colonoscopy", {
        limit: 5,
      });
      results.procedureSearch = procedureSearch;
      const autocomplete = await algoliaSearchService.getPatientSuggestions("John", 3);
      results.autocomplete = autocomplete;
      setTestResults(results);
    } catch (error) {
      setTestResults({ error: error instanceof Error ? error.message : "Unknown error" });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Card className="mx-auto w-full max-w-2xl">
      <CardHeader>
        <CardTitle>Algolia Search Service Test</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <Button onClick={runTests} disabled={isLoading}>
          {isLoading ? "Running Tests..." : "Test Algolia Search"}
        </Button>

        {testResults && (
          <div className="space-y-4">
            <div className="rounded-lg bg-gray-50 p-4">
              <h3 className="mb-2 font-medium">Test Results:</h3>
              <pre className="max-h-96 overflow-auto text-sm">{JSON.stringify(testResults, null, 2)}</pre>
            </div>

            {testResults.error && (
              <div className="rounded-lg border border-red-200 bg-red-50 p-4">
                <h4 className="font-medium text-red-800">Error:</h4>
                <p className="text-red-700">{testResults.error}</p>
              </div>
            )}

            {testResults.patientSearch && (
              <div className="rounded-lg border border-blue-200 bg-blue-50 p-4">
                <h4 className="font-medium text-blue-800">Patient Search Status:</h4>
                <p className="text-blue-700">
                  {testResults.patientSearch.success ? "Success" : "Failed"} - Using{" "}
                  {testResults.patientSearch.usingMockData ? "Mock Data" : "Algolia"}
                </p>
              </div>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
